import ConfFormGoogle from './ConfFormGoogle'

export default ConfFormGoogle